<template>
    <div class="form-edit-page">
        <div class="page-header">
            <h1>ITEM 56 - Inspeção de Supervisão do Estabelecimento</h1>
            <p class="page-subtitle">
                Laudo de inspeção sanitária anual do estabelecimento.
            </p>
        </div>

        <InspecaoSupervisaoEstabelecimentoCabecalho
            v-model="form.cabecalho"
        />

        <InspecaoSupervisaoEstabelecimentoItens
            v-model:itens="form.itens"
            v-model:observacoes="form.observacoes"
        />

        <InspecaoSupervisaoEstabelecimentoFinalizacao
            v-model="form.finalizacao"
            :totais="totais"
        />
    </div>
</template>

<script setup>
import { computed, reactive } from 'vue'
import InspecaoSupervisaoEstabelecimentoCabecalho from './InspecaoSupervisaoEstabelecimentoCabecalho.vue'
import InspecaoSupervisaoEstabelecimentoItens from './InspecaoSupervisaoEstabelecimentoItens.vue'
import InspecaoSupervisaoEstabelecimentoFinalizacao from './InspecaoSupervisaoEstabelecimentoFinalizacao.vue'
import { supervisaoEstabelecimentoSecoes } from './inspecaoSupervisaoEstabelecimento_56.js'

const criarItensIniciais = () => {
    const map = {}
    supervisaoEstabelecimentoSecoes.forEach(secao => {
        secao.subgrupos.forEach(subgrupo => {
            subgrupo.itens.forEach(item => {
                map[item.codigo] = {
                    situacao: '',
                    observacao: '',
                }
            })
        })
    })
    return map
}

const criarObservacoesIniciais = () => {
    const map = {}
    supervisaoEstabelecimentoSecoes.forEach(secao => {
        secao.subgrupos.forEach(subgrupo => {
            map[subgrupo.codigo] = ''
        })
    })
    return map
}

const form = reactive({
    cabecalho: {
        numeroLaudo: 'SIM XX/01/2025',
        razaoSocial: '',
        nomeFantasia: '',
        numeroRegistroSim: '',
        inscricaoEstadual: '',
        cnpjCpf: '',
        endereco: '',
        bairro: '',
        municipio: '',
        cep: '',
        uf: 'SC',
        telefone: '',
        email: '',
        dataInspecao: '',
        classificacaoEstabelecimento: '',
        possuiResponsavelTecnico: 'S',
        responsavelTecnicoQual: '',
        nomeResponsavelTecnico: '',
        formacaoAcademica: '',
        numeroPessoasAtividade: 0,
        numeroTurnos: 1,
        nomeAcompanhante: '',
        cpfAcompanhante: '',
        funcaoAcompanhante: '',
        motivoInspecao: 'LAUDO DE INSPEÇÃO SANITÁRIA ANUAL',
        motivoOutros: '',
    },
    itens: criarItensIniciais(),
    observacoes: criarObservacoesIniciais(),
    finalizacao: {
        disposicao: 'Prazo de 10 (dez) dias úteis para entregar por escrito ao SIM o PLA 08 - Relatório de Ações Corretivas (RAC).',
        totalNAInformado: 0,
        calculoItensUtilizaveis: 0,
        totalConformesInformado: 0,
        percentualConformidadeInformado: 0,
        grupoClassificacao: '',
        conclusaoFiscal: '',
        nomeResponsavelInspecao1: '',
        matriculaResponsavelInspecao1: '',
        assinaturaResponsavelInspecao1: '',
        nomeResponsavelInspecao2: '',
        matriculaResponsavelInspecao2: '',
        assinaturaResponsavelInspecao2: '',
        nomeResponsavelEmpresa: '',
        assinaturaResponsavelEmpresa: '',
        nomeTestemunha: '',
        assinaturaTestemunha: '',
        cidadeAssinatura: '',
        dataAssinatura: '',
    }
})

const totais = computed(() => {
    const respostas = Object.values(form.itens)

    const conforme = respostas.filter(r => r.situacao === 'C').length
    const conformeRestricao = respostas.filter(r => r.situacao === 'CR').length
    const naoConforme = respostas.filter(r => r.situacao === 'NC').length
    const naoAplicavel = respostas.filter(r => r.situacao === 'NA').length
    const totalRespondido = respostas.filter(r => !!r.situacao).length
    const totalItens = respostas.length
    const itensUtilizaveis = totalItens - naoAplicavel

    const percentualConformidade = itensUtilizaveis > 0
        ? ((conforme / itensUtilizaveis) * 100)
        : 0

    let grupo = ''
    if (percentualConformidade >= 85) grupo = 'GRUPO 01'
    else if (percentualConformidade >= 61) grupo = 'GRUPO 02'
    else grupo = 'GRUPO 03'

    return {
        totalItens,
        totalRespondido,
        conforme,
        conformeRestricao,
        naoConforme,
        naoAplicavel,
        itensUtilizaveis,
        percentualConformidade: Number(percentualConformidade.toFixed(2)),
        grupo,
    }
})
</script>

<style scoped>
.form-edit-page {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.page-header {
    background: #ffffff;
    border: 1px solid #d8dee8;
    border-radius: 10px;
    padding: 16px;
}

.page-header h1 {
    margin: 0 0 6px;
    font-size: 22px;
    color: #1f2937;
}

.page-subtitle {
    margin: 0;
    color: #6b7280;
}

</style>